module.exports = __webpack_public_path__ + "static/img/login_banner.55d942d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_banner.png
// module id = g2JE
// module chunks = 1